export function getAdminRolePermission() {
  try {
    return JSON.parse(localStorage.getItem("adminRolePermission"));
  } catch {
    return null;
  }
}
